import { Injectable } from '@angular/core';
import { KpiService } from './kpi.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class KpiDataService {
  private recruitmentsKpiDataSubject = new BehaviorSubject<any>(null);
  private employeesKpiDataSubject = new BehaviorSubject<any>(null);
  private contactKpiDataSubject = new BehaviorSubject<any>(null);
  private trainingKpiDataSubject = new BehaviorSubject<any>(null);
  private assessmentKpiDataSubject = new BehaviorSubject<any>(null);

  constructor(private kpiService: KpiService) { }

  getRecruitmentKpisData(): Observable<any> {
    if (!this.recruitmentsKpiDataSubject.value) {
      this.kpiService.getRecruitmentKpis().subscribe(res => {
        this.recruitmentsKpiDataSubject.next(res);
      });
    }
    return this.recruitmentsKpiDataSubject.asObservable();
  }

  getEmployeeKpisData(): Observable<any> {
    if (!this.employeesKpiDataSubject.value) {
      this.kpiService.getEmployeeKpis().subscribe(res => {
        this.employeesKpiDataSubject.next(res);
      });
    }
    return this.employeesKpiDataSubject.asObservable();
  }

  getContactKpisData(): Observable<any> {
    if (!this.contactKpiDataSubject.value) {
      this.kpiService.getContactKpis().subscribe(res => {
        this.contactKpiDataSubject.next(res);
      });
    }
    return this.contactKpiDataSubject.asObservable();
  }

  getTrainingKpisData(): Observable<any> {
    if (!this.trainingKpiDataSubject.value) {
      this.kpiService.getTrainingKpis().subscribe(res => {
        this.trainingKpiDataSubject.next(res);
      });
    }
    return this.trainingKpiDataSubject.asObservable();
  }

  getAssessmentKpisData(): Observable<any> {
    if (!this.assessmentKpiDataSubject.value) {
      this.kpiService.getAssessmentKpis().subscribe(res => {
        this.assessmentKpiDataSubject.next(res);
      });
    }
    return this.assessmentKpiDataSubject.asObservable();
  }
}
